module.exports = __webpack_public_path__ + "static/media/IMG_0881.fda10d58.jpg";